export default __webpack_public_path__ + "static/media/Create-documentation.fecaf257.md";